/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Actions_AriaInputs */

const en_clients_actions_aria = /** @type {(inputs: Clients_Actions_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open row actions`)
};

const pt_br2_clients_actions_aria = /** @type {(inputs: Clients_Actions_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir ações da linha`)
};

/**
* | output |
* | --- |
* | "Open row actions" |
*
* @param {Clients_Actions_AriaInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_actions_aria = /** @type {((inputs?: Clients_Actions_AriaInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Actions_AriaInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_actions_aria(inputs)
	return pt_br2_clients_actions_aria(inputs)
});